import { CostTrackingResponse, Report } from '@/app/models/costTracking';
import { formatDateMonthYear } from '@/app/utils/dateUtils';
import getReportValue from '@/app/utils/reportValueFormatter';
import DataTable, { bodyCellSx, Column } from '@/components/common/DataTable';
import TextButton from '@/components/common/TextButton';
import { TableCell, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FinalBalanceTableProps {
  setDrawerEdit: CallableFunction;
  setSelectedItem: (id: Report[]) => void;
  data: CostTrackingResponse[] | undefined;
}

export default function FinalBalanceTable({ setSelectedItem, setDrawerEdit, data }: FinalBalanceTableProps) {
  const theme = useTheme();
  const { t } = useTranslation(['costTracking', 'common']);

  const handleDrowersEdit = () => {
    setDrawerEdit(true);
  };

  const columns: Column[] = [
    { key: 'month', label: t('common:month'), width: theme.spacing(10) },
    { key: 'Done', label: t('fulfilled'), width: theme.spacing(120) },
    { key: 'actions', label: t('common:actions'), align: 'center', width: theme.spacing(15) },
  ];

  const renderRow = (item: CostTrackingResponse) => {
    return (
      <>
        <TableCell sx={bodyCellSx}>{formatDateMonthYear(item.period)}</TableCell>
        <TableCell sx={{ ...bodyCellSx }}>{getReportValue(item.reports, 'BASELINE')}</TableCell>
        <TableCell sx={{ ...bodyCellSx, textAlign: 'center' }}>
          <TextButton
            sx={{ ml: 'auto' }}
            text={`+ ${t('common:comment')}`}
            onClick={() => {
              setSelectedItem(item.reports);
              handleDrowersEdit();
            }}
          />
        </TableCell>
      </>
    );
  };

  const getRowKey = (project: CostTrackingResponse) => project.period as string;

  return (
    <DataTable
      columns={columns}
      data={data || []}
      renderRow={renderRow}
      getRowKey={getRowKey}
      emptyMessage={t('common:no.data.for.the.chosen.period.and.search.term')}
      size="small"
      maxHeight={theme.spacing(60)}
    />
  );
}
